import { LucideIcon } from "lucide-react";

interface TransformationCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  gradientFrom: string;
  gradientTo: string;
  iconColor: string;
}

const TransformationCard = ({ 
  icon: Icon, 
  title, 
  description, 
  gradientFrom,
  gradientTo, 
  iconColor
}: TransformationCardProps) => {
  return (
    <div 
      className="dark-card group animate-fade-in-up rounded-2xl p-4 sm:p-6 md:p-8 text-center"
    >
      <div className={`w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 bg-gradient-to-br from-${gradientFrom} to-${gradientTo} rounded-2xl flex items-center justify-center mx-auto mb-4 sm:mb-6 group-hover:scale-110 transition-transform duration-300`}>
        <Icon className={`h-8 w-8 sm:h-9 sm:w-9 md:h-10 md:w-10 text-${iconColor}`} />
      </div>
      <h3 className="text-lg sm:text-xl md:text-2xl font-playfair font-bold mb-3 sm:mb-4 text-white">
        {title}
      </h3>
      <p className="text-gray-300 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default TransformationCard;